import script from "./insight-metrics-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./insight-metrics-section.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__